import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { ItonicsAuthService } from '../services/itonicsAuth.service';

@Injectable()
export class AdminGuard implements CanActivate {
  constructor(private router: Router, private itonicsAuthService: ItonicsAuthService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
    return new Promise((resolve) => {
      this.itonicsAuthService.getCurrentUserGrp().subscribe((userGrp) => {
        if (userGrp.find((_grp) => _grp === 'Administrator')) {
          resolve(true);
        } else {
          // remove hash
          window.alert('You don\'t have permission to view this page');
          this.router.navigate(['/home']);
          resolve(false);
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/admin.guard.ts